
(function () {
    'use strict';

    function ctrl($uibModal) {

        const modalTemplate = `
            <div class="modal-header d-block" ng-if="!modal.hideHeader">
                <h3 class="modal-title" ng-bind="::modal.name"></h3>
            </div>
            <div class="modal-body">
                <img class="lazyload mb-3 float-right ml-3" ng-if="modal.image" src="{{ ::modal.image }}?width=200&mode=crop" />
                <p><strong>{{ ::modal.award }} ({{ modal.date }})</strong></p>
                <p ng-bind="::modal.summary"></p>
                <div ng-bind-html="::modal.content"></div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary btn-close" ng-click="modal.ok()" aria-label="close">CLOSE</button>            
            </div>`;

        this.isVisible = id => {
            const elm = document.getElementById(id);
            const date = new Date(elm.dataset.date);
            return this.currentYear === date.getFullYear() && !this.filterStr || elm.dataset.name.toLowerCase().indexOf(this.filterStr) !== -1;
        }

        this.filter = (type, val) => {
            if (type === 'year') {
                this.currentYear = val;
                this.search = undefined;
                this.filterStr = undefined;
            } else {
                if (this.search.length > 2) {
                    this.filterStr = this.search.toLowerCase();
                    this.currentYear = undefined;
                } else {
                    this.filterStr = undefined;
                }
            }
        }

        this.detail = id => {

            const modalInstance = $uibModal.open({
                template: modalTemplate,
                controller: 'honoraryModalController as modal',
                windowClass: 'honorary-modal',
                resolve: {
                    item: () => document.getElementById(id).dataset,
                    id: () => id
                }
            });

            modalInstance.rendered.then(() => {
                const modalElm = document.querySelector('.honorary-modal .modal-body');
            });
        }
    }

    angular.module('Uscapp').controller('honourRollController', ['$uibModal', ctrl]);

    /**
     * item properties will be incorrectly cased
     * @param {any} $uibModalInstance
     * @param {any} $sce
     * @param {any} item
     */
    function honoraryModalController($uibModalInstance, $sce, $filter, contentService, item, id) {

        angular.extend(this, {
            image: item.image,
            name: item.name,
            award: item.award,
            date: $filter('date')(new Date(item.date), 'MMMM yyyy'),

            ok: () => {
                $uibModalInstance.close();
            }
        });

        // use the id to fetch the citation and summary, as these are potentially large strings x 100 or so honoraries
        const query = {
            "searchType": 'SearchSearcher',
            "contentTypes": ['honorary'],
            "fields": ['citation', 'summary'],
            "html": true,
            "query": {
                "id": id
            }
        };

        contentService.get(query)
            .then(resp => {
                if (resp[0]) {
                    this.content = $sce.trustAsHtml(resp[0].citation);
                    this.summary = resp[0].summary;
                }
            });
    }

    angular.module('Uscapp').controller('honoraryModalController', ['$uibModalInstance', '$sce', '$filter', 'contentService', 'item', 'id', honoraryModalController]);
}());